<template>
    <v-container fluid id="servicios">

            <v-row class="text-center">
                <v-col col="12">
                <h1 class="font-weight-bold text-h4 mb--1 pa-12">
                    SERVICIOS
                </h1>
                </v-col>
            </v-row>
            <v-row class="text-center" sm="12">
                     <!--  <v-col col="12">
                          <blockquote class="blockquote">
                          <p>
                            Experiencia y juventud, junto con amplios conocimientos en el sector tecnológico, se combinan
                            a la perfeción para darte la respuesta más adecuada en cada necesidad que se le pueda plantear en el mundo
                            tecnológico.
                          </p>
                          </blockquote>
                      </v-col> -->
            </v-row>
            <v-row justify="space-around">
                <v-col cols="12" sm="3" md="4" lg="4"
                v-for="(item,i) in services" :key="i">

                <v-dialog
                transition="dialog-bottom-transition"
                max-width="500"
                >
                  <template v-slot:activator="{ on, attrs }">

                    <!--Servicios -->
                    <v-card  width="auto" elevation="5"  outlined tile>
                              <v-img
                              height="auto"
                              :src="item.img"
                              ></v-img>
                              <v-card-actions>
                                  <v-btn
                                    color="indigo"
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                    > Leer Más
                                  </v-btn>
                              </v-card-actions>
                          </v-card>
                  </template>

                  <!--Flyers -->
                  <template v-slot:default="dialog">
                    <v-card>
                      <!-- <v-card-text> -->
                        <v-img
                              height="auto"
                              :src="item.flyer"
                              ></v-img>
                        <!-- <div class="text-h5 pa-12" >
                          {{item.name}}
                        </div> -->
                      <!-- </v-card-text> -->
                      <v-divider></v-divider>
                      <v-card-actions class="justify-end">
                        <v-btn
                          text
                          @click="dialog.value = false"
                        >Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
              </v-dialog>
                </v-col>
            </v-row>

    </v-container>
</template>

<script>
import axios from 'axios'
const BASE_URL = 'https://innuvex.com/'

export default {
  data () {
    return {
      services: [],
      dialog: false
    }
  },
  mounted () {
    this.getServices()
  },
  methods: {
    getServices () {
      var self = this
      // filtered = services.reduce((acc, item, index) => ((item.flyer) ? [...acc, index] : acc), []);
      axios({
        method: 'GET',
        url: BASE_URL + 'apiv1/service/'
      }).then((response) => {
        self.services = response.data.map((key) => {
          return {
            flyer: key.flyer,
            id: key.id,
            name: key.service_name,
            description: key.service_short_desc,
            img: key.image
          }
        })
      }).catch((e) => {
        console.error(e)
      })
    }
  }
}
</script>
